export default __webpack_public_path__ + "static/media/copy-logo.41eee603.svg";